import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock, getOptionsCode } from '../Util'
import Mutators from '../Mutators'

Mutators.registerOptionsMutator('sirenia_excel_options_mutator', {
  range: { type: 'String' },
  sheet: { type: 'String' },
  header: { label: 'header?', type: 'Boolean' },
  index: { label: 'index?', type: 'Boolean' }
})

defineBlock(
  'sirenia_api_excel_load',
  {
    message0: 'excel data from %1',
    args0: [
      {
        type: 'input_value',
        name: 'PATH',
        check: 'String'
      }
    ],
    tooltip: 'Loads data from an excel file',
    output: null,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#excel',
    mutator: 'sirenia_excel_options_mutator'
  },
  function(block) {
    var path =
      Blockly.JavaScript.valueToCode(block, 'PATH', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    const optionsObject = getOptionsCode(this.chosenProps, block)
    const secondArg = this.chosenProps.length > 0 ? `{ table: ${optionsObject}}` : '{}'
    return [`Excel.load(${path}, ${secondArg})`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_excel_delete_sheet',
  {
    message0: 'delete sheet %1 in excel file %2',
    args0: [
      {
        type: 'input_value',
        name: 'SHEET',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'PATH',
        check: 'String'
      }
    ],
    inputsInline: true,
    tooltip: 'Removes a single sheet from the workbook',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#delete-a-sheet'
  },
  function(block) {
    var sheet =
      Blockly.JavaScript.valueToCode(block, 'SHEET', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var path =
      Blockly.JavaScript.valueToCode(block, 'PATH', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Excel.deleteSheet(${path}, ${sheet});\n`
  }
)

defineStmtBlock(
  'sirenia_api_excel_updatecell',
  {
    message0: 'update excel file %1 sheet %2 cell %3 with value %4',
    args0: [
      {
        type: 'input_value',
        name: 'PATH',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'SHEET',
        check: 'String',
        align: 'RIGHT'
      },
      {
        type: 'input_value',
        name: 'CELL',
        check: 'String',
        align: 'RIGHT'
      },
      {
        type: 'input_value',
        name: 'VALUE',
        align: 'RIGHT'
      }
    ],
    tooltip: "Write a value to a cell in excel file. Creates the file if it doesn't exist",
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#update-single-cell'
  },
  function(block) {
    var path =
      Blockly.JavaScript.valueToCode(block, 'PATH', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var sheet =
      Blockly.JavaScript.valueToCode(block, 'SHEET', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var cell =
      Blockly.JavaScript.valueToCode(block, 'CELL', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var value =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Excel.updateCell(${path}, ${sheet}, ${cell}, ${value});\n`
  }
)

defineStmtBlock(
  'sirenia_api_excel_updatecells',
  {
    message0: 'update excel file %1 sheet %2 starting at cell %3 with data %4',
    args0: [
      {
        type: 'input_value',
        name: 'PATH',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'SHEET',
        check: 'String',
        align: 'RIGHT'
      },
      {
        type: 'input_value',
        name: 'CELL',
        check: 'String',
        align: 'RIGHT'
      },
      {
        type: 'input_value',
        name: 'DATA',
        align: 'RIGHT'
      }
    ],
    tooltip: "Write data to a sheet in an excel file. Creates the file if it doesn't exist",
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#update-multiple-cells'
  },
  function(block) {
    var path =
      Blockly.JavaScript.valueToCode(block, 'PATH', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var sheet =
      Blockly.JavaScript.valueToCode(block, 'SHEET', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var cell =
      Blockly.JavaScript.valueToCode(block, 'CELL', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var data =
      Blockly.JavaScript.valueToCode(block, 'DATA', Blockly.JavaScript.ORDER_ATOMIC) || '[]'
    return `Excel.updateCells(${path}, ${sheet}, ${cell}, ${data});\n`
  }
)
